// Generated by purs version 0.15.15
import * as Data_Bounded_Generic from "../Data.Bounded.Generic/index.js";
import * as Data_Enum_Generic from "../Data.Enum.Generic/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Ordering from "../Data.Ordering/index.js";
import * as Data_Record from "../Data.Record/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_EnumEncoding from "../Foreign.Generic.EnumEncoding/index.js";
import * as Restaumatic_CoreSites_Translations_Keys from "../Restaumatic.CoreSites.Translations.Keys/index.js";
import * as Restaumatic_Form_Metadata from "../Restaumatic.Form.Metadata/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Restaumatic_I18n from "../Restaumatic.I18n/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
import * as Unscramble_Enum from "../Unscramble.Enum/index.js";
var genericShowConstructor = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments);
var DeliveryIsSymbol = {
    reflectSymbol: function () {
        return "Delivery";
    }
};
var TakeawayIsSymbol = {
    reflectSymbol: function () {
        return "Takeaway";
    }
};
var DineInIsSymbol = {
    reflectSymbol: function () {
        return "DineIn";
    }
};
var NoContactDeliveryIsSymbol = {
    reflectSymbol: function () {
        return "NoContactDelivery";
    }
};
var genericTopConstructor = /* #__PURE__ */ Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments);
var genericBottomConstructor = /* #__PURE__ */ Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments);
var genericBottomSum = /* #__PURE__ */ Data_Bounded_Generic.genericBottomSum(genericBottomConstructor);
var genericEnumConstructor = /* #__PURE__ */ Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments);
var genericEnumSum = /* #__PURE__ */ Data_Enum_Generic.genericEnumSum(genericEnumConstructor)(genericTopConstructor);
var genericEnumSum1 = /* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(genericEnumConstructor)(genericBottomConstructor))(genericBottomSum))(genericBottomSum);
var genericBoundedEnumConstructor = /* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments);
var genericBoundedEnumSum = /* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumSum(genericBoundedEnumConstructor);
var genericBoundedEnumSum1 = /* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(genericBoundedEnumConstructor)));
var Delivery = /* #__PURE__ */ (function () {
    function Delivery() {

    };
    Delivery.value = new Delivery();
    return Delivery;
})();
var Takeaway = /* #__PURE__ */ (function () {
    function Takeaway() {

    };
    Takeaway.value = new Takeaway();
    return Takeaway;
})();
var DineIn = /* #__PURE__ */ (function () {
    function DineIn() {

    };
    DineIn.value = new DineIn();
    return DineIn;
})();
var NoContactDelivery = /* #__PURE__ */ (function () {
    function NoContactDelivery() {

    };
    NoContactDelivery.value = new NoContactDelivery();
    return NoContactDelivery;
})();
var getTranslationFulfillment = {
    getTranslation: function (v) {
        return {
            Delivery: {
                label: Restaumatic_I18n.translate_(Restaumatic_CoreSites_Translations_Keys.t.FulfillmentMethodType.Delivery.label)
            },
            Takeaway: {
                label: Restaumatic_I18n.translate_(Restaumatic_CoreSites_Translations_Keys.t.FulfillmentMethodType.Takeaway.label)
            },
            DineIn: {
                label: Restaumatic_I18n.translate_(Restaumatic_CoreSites_Translations_Keys.t.FulfillmentMethodType.DineIn.label)
            },
            NoContactDelivery: {
                label: Restaumatic_I18n.translate_(Restaumatic_CoreSites_Translations_Keys.t.FulfillmentMethodType.NoContactDelivery.label)
            }
        };
    }
};
var eqFulfillmentMethodType = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Delivery && y instanceof Delivery) {
                return true;
            };
            if (x instanceof Takeaway && y instanceof Takeaway) {
                return true;
            };
            if (x instanceof DineIn && y instanceof DineIn) {
                return true;
            };
            if (x instanceof NoContactDelivery && y instanceof NoContactDelivery) {
                return true;
            };
            return false;
        };
    }
};
var ordFulfillmentMethodType = {
    compare: function (x) {
        return function (y) {
            if (x instanceof Delivery && y instanceof Delivery) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Delivery) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Delivery) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Takeaway && y instanceof Takeaway) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Takeaway) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Takeaway) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof DineIn && y instanceof DineIn) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof DineIn) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof DineIn) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof NoContactDelivery && y instanceof NoContactDelivery) {
                return Data_Ordering.EQ.value;
            };
            throw new Error("Failed pattern match at Restaumatic.Orders.Types.FulfillmentMethodType (line 0, column 0 - line 0, column 0): " + [ x.constructor.name, y.constructor.name ]);
        };
    },
    Eq0: function () {
        return eqFulfillmentMethodType;
    }
};
var genericFulfillmentMethodType = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return Delivery.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return Takeaway.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return DineIn.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inr)) {
            return NoContactDelivery.value;
        };
        throw new Error("Failed pattern match at Restaumatic.Orders.Types.FulfillmentMethodType (line 49, column 1 - line 49, column 97): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Delivery) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof Takeaway) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof DineIn) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)));
        };
        if (x instanceof NoContactDelivery) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value)));
        };
        throw new Error("Failed pattern match at Restaumatic.Orders.Types.FulfillmentMethodType (line 49, column 1 - line 49, column 97): " + [ x.constructor.name ]);
    }
};
var showFulfillmentMethodType = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericFulfillmentMethodType)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(DeliveryIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(TakeawayIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(DineInIsSymbol))(/* #__PURE__ */ genericShowConstructor(NoContactDeliveryIsSymbol)))))
};
var unscrambleDecodeFulfillmentMethodType = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Enum.genericUnsafeDecodeEnum(genericFulfillmentMethodType)(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct(DeliveryIsSymbol))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct(TakeawayIsSymbol))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct(DineInIsSymbol))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct(NoContactDeliveryIsSymbol)))))(Unscramble_Enum.defaultEnumOptions)
};
var boundedFulfillmentMethodT = {
    top: /* #__PURE__ */ Data_Bounded_Generic.genericTop(genericFulfillmentMethodType)(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(genericTopConstructor)))),
    bottom: /* #__PURE__ */ Data_Bounded_Generic.genericBottom(genericFulfillmentMethodType)(genericBottomSum),
    Ord0: function () {
        return ordFulfillmentMethodType;
    }
};
var enumFulfillmentMethodType = {
    succ: /* #__PURE__ */ Data_Enum_Generic.genericSucc(genericFulfillmentMethodType)(genericEnumSum1),
    pred: /* #__PURE__ */ Data_Enum_Generic.genericPred(genericFulfillmentMethodType)(genericEnumSum1),
    Ord0: function () {
        return ordFulfillmentMethodType;
    }
};
var boundedEnumFulfillmentMet = {
    cardinality: /* #__PURE__ */ Data_Enum_Generic.genericCardinality(genericFulfillmentMethodType)(genericBoundedEnumSum1),
    toEnum: /* #__PURE__ */ Data_Enum_Generic.genericToEnum(genericFulfillmentMethodType)(genericBoundedEnumSum1),
    fromEnum: /* #__PURE__ */ Data_Enum_Generic.genericFromEnum(genericFulfillmentMethodType)(genericBoundedEnumSum1),
    Bounded0: function () {
        return boundedFulfillmentMethodT;
    },
    Enum1: function () {
        return enumFulfillmentMethodType;
    }
};
var getEnumOptions = /* #__PURE__ */ Restaumatic_Form_Metadata.getEnumOptions(genericFulfillmentMethodType)(boundedEnumFulfillmentMet)(enumFulfillmentMethodType)(/* #__PURE__ */ Restaumatic_Form_Metadata.gEnumOptionsSum(/* #__PURE__ */ Restaumatic_Form_Metadata.gEnumOptionsConstructorNo(DeliveryIsSymbol)(getTranslationFulfillment)(/* #__PURE__ */ Data_Record.hasFieldRecord(DeliveryIsSymbol)()))(/* #__PURE__ */ Restaumatic_Form_Metadata.gEnumOptionsSum(/* #__PURE__ */ Restaumatic_Form_Metadata.gEnumOptionsConstructorNo(TakeawayIsSymbol)(getTranslationFulfillment)(/* #__PURE__ */ Data_Record.hasFieldRecord(TakeawayIsSymbol)()))(/* #__PURE__ */ Restaumatic_Form_Metadata.gEnumOptionsSum(/* #__PURE__ */ Restaumatic_Form_Metadata.gEnumOptionsConstructorNo(DineInIsSymbol)(getTranslationFulfillment)(/* #__PURE__ */ Data_Record.hasFieldRecord(DineInIsSymbol)()))(/* #__PURE__ */ Restaumatic_Form_Metadata.gEnumOptionsConstructorNo(NoContactDeliveryIsSymbol)(getTranslationFulfillment)(/* #__PURE__ */ Data_Record.hasFieldRecord(NoContactDeliveryIsSymbol)())))));
var getOptionsFulfillmentMeth = {
    getOptions: function (v) {
        return getEnumOptions(Type_Proxy["Proxy"].value);
    }
};
var toFillFormTypeFulfillment = {
    fillFormDataType: /* #__PURE__ */ Restaumatic_Form_TestHelpers.defaultEnumFillFormDataType(genericFulfillmentMethodType)(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeSum(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeConstr(DeliveryIsSymbol))(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeSum(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeConstr(TakeawayIsSymbol))(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeSum(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeConstr(DineInIsSymbol))(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeConstr(NoContactDeliveryIsSymbol)))))
};
var encodeFulfillmentMethodType = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEnumEncode(genericFulfillmentMethodType)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum(DeliveryIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum(TakeawayIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum(DineInIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum(NoContactDeliveryIsSymbol)))))
};
var decodeFulfillmentMethodType = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultEnumDecode(genericFulfillmentMethodType)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum(DeliveryIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum(TakeawayIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum(DineInIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum(NoContactDeliveryIsSymbol)))))
};
export {
    Delivery,
    Takeaway,
    DineIn,
    NoContactDelivery,
    getTranslationFulfillment,
    getOptionsFulfillmentMeth,
    genericFulfillmentMethodType,
    eqFulfillmentMethodType,
    showFulfillmentMethodType,
    encodeFulfillmentMethodType,
    decodeFulfillmentMethodType,
    unscrambleDecodeFulfillmentMethodType,
    ordFulfillmentMethodType,
    enumFulfillmentMethodType,
    boundedFulfillmentMethodT,
    boundedEnumFulfillmentMet,
    toFillFormTypeFulfillment
};
